const TextInput = ({ value, onChange }) => {
  return (
    <textarea
      className="w-full border rounded-lg p-3"
      rows={3}
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      placeholder="Enter your answer"
    />
  );
};

export default TextInput;
